import { Button as AriesButton, ScreenSize } from 'glints-aries';
import styled from 'styled-components';

import { buttonLoadingStyle } from './ButtonLoading.sc';
import {
  outlineJobActionStyle,
  solidJobActionStyle,
} from './JobActionButton.sc';

export const ApplyButton = styled.div<{
  compact?: boolean;
  hasAppliedInApplyOnAppExp?: boolean;
}>`
  ${({ hasAppliedInApplyOnAppExp }) =>
    hasAppliedInApplyOnAppExp &&
    `
      &&&& {
        display: none;
      }
    `}

  .solid-btn-content {
    font-size: 14px;
    letter-spacing: 1px;
    padding: 10px 20px;
    @media (min-width: ${ScreenSize.desktopS}px) {
      ${({ compact }) => !compact && 'min-width: 156px'};
    }
  }
`;

export const Button = styled(AriesButton)<{ $isLoading?: boolean }>`
  .ghostbtn-content {
    ${outlineJobActionStyle}
  }

  .solid-btn-content {
    ${solidJobActionStyle}
  }

  @media (min-width: ${ScreenSize.desktopS}px) {
    white-space: nowrap;
  }

  ${({ $isLoading }) => $isLoading && buttonLoadingStyle}
`;
